import { joinParts } from './utils'

export const notifications = {
  tickets: (uuid: string) => joinParts('notification', uuid),
}
